export default __webpack_public_path__ + "content/110e781b605b33c1b949efa8510ee8b9.ttf";